"use client";

import clsx from "clsx";
import DynamicCanvasReveal from "./DynamicCanvasReveal";
import { useWebGL2 } from "./useWebGL";

export default function SpotlightDotsFooter({
  children,
  withFadeMask = false,
  disabled = false,
}: {
  children: React.ReactNode;
  withFadeMask?: boolean;
  disabled?: boolean;
}) {
  const webGL2Supported = useWebGL2();

  if (disabled || !webGL2Supported) {
    return null;
  }

  return (
    <section
      className={clsx(
        "relative flex lg:flex-row flex-col items-center justify-between gap-4 min-h-fit lg:-ml-[50%] lg:-mr-[50%]"
      )}
    >
      <div className="absolute inset-0 z-10 lg:flex justify-evenly opacity-0 animate-fade-in hidden">
        <div
          className="w-1/2 h-full"
          style={
            {
              "--mask-position-x": "40%",
              "--mask-position-y": "60%",
              background:
                "radial-gradient(ellipse 69% 70% at var(--mask-position-x) var(--mask-position-y), rgba(255, 0, 0, 0.07) 0%, rgba(255, 0, 0, 0.05) 30%, rgb(16 16 16 / var(--tw-bg-opacity)) 90%, #101010 100%)",
              pointerEvents: "none",
            } as React.CSSProperties
          }
        />
        <div
          className="w-1/2 h-full"
          style={
            {
              "--mask-position-x": "60%",
              "--mask-position-y": "60%",
              background:
                "radial-gradient(ellipse 69% 70% at var(--mask-position-x) var(--mask-position-y), rgba(253, 111, 64, 0.07) 0%, rgba(253, 111, 64, 0.05) 30%, rgb(16 16 16 / var(--tw-bg-opacity)) 90%, #101010 100%)",
              pointerEvents: "none",
            } as React.CSSProperties
          }
        />
      </div>
      {withFadeMask && (
        <div className="pointer-events-none absolute top-0 left-0 right-0 z-10 h-12 bg-linear-to-b from-[#101010] to-transparent" />
      )}
      <div className="relative z-50 mx-auto">{children}</div>
      <div className="absolute w-full h-full inset-0 lg:flex items-center justify-center opacity-70 hidden">
        <DynamicCanvasReveal
          animationSpeed={0.5}
          containerClassName="bg-transparent"
          colors={[
            [255, 45, 45], // Dark red for outer dots
            [255, 71, 71], // Medium red
            [255, 99, 99], // Light red for center
          ]}
          dotSize={4} // 4x4 pixel dots
          totalSize={14} // Spacing between dots
          opacities={[0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.6, 0.7]}
        />
        {/* Radial gradient overlay for the glowing effect */}
        <div className="absolute inset-0 -z-30 bg-[radial-gradient(ellipse_at_center,rgba(255,45,45,0.15)_0%,rgba(255,45,45,0.05)_30%,rgba(16,16,16,0)_70%)]" />
      </div>
      {withFadeMask && (
        <div className="pointer-events-none absolute bottom-0 left-0 right-0 z-10 h-12 bg-linear-to-t from-[#101010] to-transparent" />
      )}
    </section>
  );
}
